/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Employment } from '../models/Employment';
import type { PatchedEmployment } from '../models/PatchedEmployment';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class EmploymentService {
  /**
   * List Employments for a contact.
   * @returns Employment
   * @throws ApiError
   */
  public static employmentEmployeeList({
    organisationUid,
    all,
    o,
  }: {
    organisationUid: string,
    all?: boolean,
    o?: string,
  }): CancelablePromise<Array<Employment>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v5/organisations/{organisation__uid}/employment/employee',
      path: {
        'organisation__uid': organisationUid,
      },
      query: {
        'all': all,
        'o': o,
      },
    });
  }
  /**
   * List Employments.
   * @returns Employment
   * @throws ApiError
   */
  public static employmentManagerList({
    organisationUid,
    all,
    contactUid,
    o,
  }: {
    organisationUid: string,
    all?: boolean,
    contactUid?: string,
    o?: string,
  }): CancelablePromise<Array<Employment>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v5/organisations/{organisation__uid}/employment/manager',
      path: {
        'organisation__uid': organisationUid,
      },
      query: {
        'all': all,
        'contact_uid': contactUid,
        'o': o,
      },
    });
  }
  /**
   * View set for the Employment objects.
   * @returns Employment
   * @throws ApiError
   */
  public static employmentManagerCreate({
    organisationUid,
    requestBody,
  }: {
    organisationUid: string,
    requestBody: Employment,
  }): CancelablePromise<Employment> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v5/organisations/{organisation__uid}/employment/manager',
      path: {
        'organisation__uid': organisationUid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * View set for the Employment objects.
   * @returns Employment
   * @throws ApiError
   */
  public static employmentManagerRetrieve({
    organisationUid,
    uid,
  }: {
    organisationUid: string,
    uid: string,
  }): CancelablePromise<Employment> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v5/organisations/{organisation__uid}/employment/manager/{uid}',
      path: {
        'organisation__uid': organisationUid,
        'uid': uid,
      },
    });
  }
  /**
   * View set for the Employment objects.
   * @returns Employment
   * @throws ApiError
   */
  public static employmentManagerUpdate({
    organisationUid,
    uid,
    requestBody,
  }: {
    organisationUid: string,
    uid: string,
    requestBody: Employment,
  }): CancelablePromise<Employment> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/v5/organisations/{organisation__uid}/employment/manager/{uid}',
      path: {
        'organisation__uid': organisationUid,
        'uid': uid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * View set for the Employment objects.
   * @returns Employment
   * @throws ApiError
   */
  public static employmentManagerPartialUpdate({
    organisationUid,
    uid,
    requestBody,
  }: {
    organisationUid: string,
    uid: string,
    requestBody?: PatchedEmployment,
  }): CancelablePromise<Employment> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v5/organisations/{organisation__uid}/employment/manager/{uid}',
      path: {
        'organisation__uid': organisationUid,
        'uid': uid,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * View set for the Employment objects.
   * @returns void
   * @throws ApiError
   */
  public static employmentManagerDestroy({
    organisationUid,
    uid,
  }: {
    organisationUid: string,
    uid: string,
  }): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v5/organisations/{organisation__uid}/employment/manager/{uid}',
      path: {
        'organisation__uid': organisationUid,
        'uid': uid,
      },
    });
  }
}
